import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowDown01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';
import { Fragment } from 'react';
import { m } from '../../../paraglide/messages';

/** The route a page takes, cheapest scraper first. Generic on purpose: never
 *  a source name or price (engineering/decisions.md, provider disclosure). */
const STEPS = [
  { name: m.scrape_router_step_cheapest, note: m.scrape_router_step_cheapest_note },
  { name: m.scrape_router_step_next, note: m.scrape_router_step_next_note },
  { name: m.scrape_router_step_browser, note: m.scrape_router_step_browser_note },
];

/** Relative cost as one to three filled dots; never a price. */
const CostDots = ({ level }: { level: number }) => (
  <span className="flex gap-0.5" aria-hidden>
    {STEPS.map((_, i) => (
      <span key={i} className={`size-1.5 rounded-full ${i <= level ? 'bg-accent' : 'bg-line'}`} />
    ))}
  </span>
);

/** The three steps side by side, stacked with down arrows on a phone. */
export const ScrapeRouterSteps = ({ className = '' }: { className?: string }) => (
  <ol className={`flex flex-col gap-2 s720:flex-row s720:items-stretch ${className}`}>
    {STEPS.map((step, i) => (
      <Fragment key={i}>
        {i > 0 ? (
          <li aria-hidden className="grid place-items-center text-text-3">
            <HugeiconsIcon icon={ArrowDown01Icon} size={16} className="s720:hidden" />
            <HugeiconsIcon icon={ArrowRight01Icon} size={16} className="max-s720:hidden" />
          </li>
        ) : null}
        <li className={`flex-1 rounded-12 border px-4 py-3 ${i === 0 ? 'border-accent-line bg-accent-soft' : 'border-rule bg-surface'}`}>
          <CostDots level={i} />
          <span className="mt-2 block text-14 font-medium text-text">{step.name()}</span>
          <span className="mt-0.5 block text-12 leading-snug text-text-3">{step.note()}</span>
        </li>
      </Fragment>
    ))}
  </ol>
);
